import { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

export const useFetchFriends = () => {
    const [friends, setFriends] = useState([]);
    const [loading, setLoading] = useState(true);
    const { getAccessTokenSilently } = useAuth0();
    const apiUrl = process.env.REACT_APP_API_URL;

    const fetchFriends = async () => {
        setLoading(true);
        const token = await getAccessTokenSilently({
            authorizationParams: {
                audience: process.env.REACT_APP_API_AUDIENCE,
            }
        });

        const response = await fetch(`${apiUrl}/api/friends/GetFriends`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        if (response.ok) {
            const data = await response.json();
            setFriends(data);
        } else {
            console.error('Failed to fetch friends');
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchFriends();
    }, [getAccessTokenSilently, apiUrl]);

    return {
        friends,
        setFriends,
        loading,
        refreshFriends: fetchFriends,
    };
};
